import React from 'react';
import PaymentLayout from './layout/PaymentLayout';
import InitPaymentForm from './forms/InitPaymentForm';

class Home extends React.Component {

  render() {
    return (
      <PaymentLayout>
        <InitPaymentForm />
      </PaymentLayout>
    );
  }
  
}

export default Home;